<div class="download-dialog">
  <div class="download-dialog-header">
    <h2>{{ labels.title }}</h2>
  </div>
  <div class="download-dialog-body">
    <section>
      <h4>{{ labels.targetDuration }}</h4>
      <app-date-filter></app-date-filter>
    </section>

    <section>
      <h4>{{ labels.targetData }}</h4>
      <ul class="download-data">
        <li>
          <input
            type="checkbox"
            id="all"
            (change)="onToggleAll($event)"
            [checked]="isAllChecked()"
          />
          <label for="all">{{ labels.checkAll }}</label>
        </li>
        @for (dataTarget of dataTargets; track dataTarget) {
          <li class="download-data">
            <input
              type="checkbox"
              id="dataTarget{{ dataTarget.id }}"
              (change)="onToggleDataTarget($event, dataTarget)"
              [checked]="dataTarget.willDownload"
            />
            <label for="dataTarget{{ dataTarget.id }}">{{
              dataTarget.name
            }}</label>
          </li>
        }
      </ul>
    </section>

    <section>
      <h4>{{ labels.fileFormat }}</h4>

      <div class="download-format">
        <input
          type="radio"
          id="csv"
          name="format"
          (change)="onChangeFileType($event)"
          value="csv"
          checked
        />
        <label for="csv">CSV</label>
      </div>

      <div class="download-format">
        <input
          type="radio"
          id="xlsx"
          name="format"
          (change)="onChangeFileType($event)"
          value="xlsx"
        />
        <label for="xlsx">xlsx(Excel)</label>
      </div>
    </section>

    <section class="download-dialog-buttons">
      <button class="download-button" (click)="download()">
        {{ labels.download }}
      </button>
      <button class="cancel-button" (click)="toggleDownloadDialog()">
        {{ labels.cancel }}
      </button>
    </section>
  </div>
</div>
